export default __webpack_public_path__ + "static/media/logo_icon.5f768884.png";